import { useEffect, useState } from 'react';
import { validateRetrievedRecord, type RetrievedRecord } from '../utils/retrievedResultsPreview';
// A compile-time conditional removes the fixture import and its payload from non-dev builds.
const loadDevelopmentFixture = import.meta.env.COURTCAPTAIN_ENV === 'development' ? async (matchId: string) => {
 const {retrievedPilotFixtures}=await import('../dev/retrieved-results/fixtures');
 return validateRetrievedRecord(retrievedPilotFixtures.find(f=>f.courtCaptainMatchId===matchId),matchId,'development_fixture');
} : null;
export function useRetrievedResultsFixture(matchId: string, allowed: boolean): RetrievedRecord | null {
 const [record,setRecord]=useState<RetrievedRecord|null>(null);
 useEffect(()=>{
  let active=true;setRecord(null);
  if(loadDevelopmentFixture && allowed && new URLSearchParams(window.location.search).get('retrievedResults')==='pilot') {
   void loadDevelopmentFixture(matchId).then(fixture=>{if(active)setRecord(fixture);}).catch(()=>{if(active)setRecord(null);});
  }
  return ()=>{active=false;};
 },[matchId,allowed]);
 return allowed&&record?.matchId===matchId?record:null;
}
